import defaultConfig from '../constants/config/default-config'
import { matchRule } from '../helpers'

export const getValue = (value) => {
  try {
    return JSON.parse(value.asString())
  } catch {
    return value.asString()
  }
}

export const getCurrentEnv = ({ hostname = window.location.hostname, environments = defaultConfig.environments }) => {
  const [env] = environments.find(([_, ...rules]) => rules.some((rule) => matchRule(hostname, rule))) || [null]
  return env
}

export const getSectionNameFromUrl = (url: string): string => {
  const regexOnlyNumbers = /^[0-9]*$/
  const lastPartUrl = url.split('/')?.slice(-1)[0]
  const index = lastPartUrl === '' || lastPartUrl.match(regexOnlyNumbers) ? -2 : -1
  const sectionName = url.split('/')?.slice(index)[0]?.replace('-', ' ')
  const sectionCamelCase = sectionName.substring(0, 1).toUpperCase() + sectionName.substring(1).toLowerCase()
  const section = sectionCamelCase === 'Empresas' ? 'Home' : sectionCamelCase

  return section
}
